module.exports = __webpack_public_path__ + "static/media/ig22.77995b5e.jpg";